(function contentListing($, Drupal, once) {
  Drupal.behaviors.rutherfordContentListing = {
    attach(context) {
      $(once('rutherford-content-listing', '[data-content-listing]', context))
        .each(function eachContentListing() {
          const $pagerLinks = $(this).find('[data-pager] li a');
          const id = $(this).attr('id');

          $pagerLinks.each(function rewriteHrefs() {
            $(this).attr('href', `${$(this).attr('href')}#${id}`);
          });
        });
    },
  };
})(jQuery, Drupal, once);
